import EvaluationSideBar from './EvaluationSideBar'

export default EvaluationSideBar
